import React, { type FC, type PropsWithChildren } from 'react'
import clsx from 'clsx'

const Main: FC<
  PropsWithChildren<{ className?: string; fullWidth?: boolean }>
> = ({ children, className, fullWidth = false }) => {
  return (
    <main
      className={clsx(className, 'flex flex-col flex-1', {
        container: !fullWidth,
      })}
    >
      {children}
    </main>
  )
}

export default Main
